import styled from 'styled-components';
import { BreakpointRange, WithBreakpointRange } from '@mews-commander/ui';

interface OccupancyReportDateProps extends WithBreakpointRange {
    utcDate: string;
}

interface DateComponentProps {
    utcString: string;
}

type OccupancyReportDateComponent = React.FC<DateComponentProps>;

interface OccupancyReportDateProps {
    PrimaryTitleComponent: OccupancyReportDateComponent;
    ShortPrimaryTitleComponent: OccupancyReportDateComponent;
    SecondaryTitleComponent: OccupancyReportDateComponent;
}

const OccupancyReportDate =
    ({ PrimaryTitleComponent, ShortPrimaryTitleComponent, SecondaryTitleComponent }: OccupancyReportDateProps) =>
    ({ utcDate, breakpointRange }: OccupancyReportDateProps) => (
        <Wrapper>
            <div>
                {breakpointRange === BreakpointRange.LargeDesktop ? (
                    <PrimaryTitleComponent utcString={utcDate} />
                ) : (
                    <ShortPrimaryTitleComponent utcString={utcDate} />
                )}
            </div>
            <SecondaryTitleComponent utcString={utcDate} />
        </Wrapper>
    );

const Wrapper = styled.td`
    text-align: center;
`;

export default OccupancyReportDate;
